export const GAME_SPEED_TYPES = {
  standard: 'standard',
  fast: 'fast',
  turbo: 'turbo',
};

export const QUICK_BETS_COUNT_BY_PAGE = 5;

export const specificLocalStorageKeys = { isHideIntro: 'isHideIntro' };

export const JACK_POT_AMOUNT_KEY = {
  1: 'clubAmount',
  2: 'diamondAmount',
  3: 'heartAmount',
  4: 'spadeAmount',
};

export const GAMBLE_CARDS = {
  Red: 1,
  Black: 2,
};

export const MAX_USER_INACTIVE_STATE_DURATION = 900000;
